import React, { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setVehicle } from "../../redux/slices/addVehicleSlice";
import { ExtraImages } from "..";
import { showToast } from "../../utils/showToast";
import ReactPlayer from "react-player";
import { FFmpeg } from "@ffmpeg/ffmpeg";
import Loading from "../loading/Loading";
import { RiDeleteBin5Line } from "react-icons/ri";
import { IoCloudUploadOutline } from "react-icons/io5";
import { RootState } from "../../redux/store";
import { base64StringToFile, fileToBase64 } from "../../utils/stringToBytes32";

const Gallery: React.FC = () => {
  const gallery = useSelector(
    (state: RootState) => state.addVehicle.Vehicle[0]?.gallery
  );

  const video = useSelector(
    (state: RootState) => state.addVehicle.Vehicle[0]?.video
  );

  const [isVideoCompressing, setIsVideoCompressing] = useState<boolean>(false);

  const [isDraggingOver, setIsDraggingOver] = useState<boolean>(false);

  const [selectedImages, setSelectedImages] = useState<File[]>([]);
  const [categorizedImages, setCategorizedImages] = useState<{
    front: File | undefined;
    back: File | undefined;
    left: File | undefined;
    right: File | undefined;
    interiorFront: File | undefined;
    interiorBack: File | undefined;
  }>({} as any);
  const [selectedVideo, setSelectedVideo] = useState<File | undefined>(
    undefined
  );
  const [compressedVideo, setCompressedVideo] = useState<File | undefined>(
    undefined
  );

  const onSelectFile = (event: React.ChangeEvent<HTMLInputElement>) => {
    const selectedFiles = event.target.files;
    // console.log("selectedFiles", selectedFiles);

    if (selectedFiles) {
      const selectedFilesArray = Array.from(selectedFiles);

      const imagesArray = selectedFilesArray.map((file) => {
        // console.log(file);
        // setSelectedImages([...selectedImages, file]);
        return file;
      });

      // console.log("imagesArray", imagesArray);
      // console.log("selectedImages", selectedImages);

      let allImages;
      if (selectedImages) {
        allImages = [...selectedImages, ...imagesArray];
      } else {
        allImages = [...imagesArray];
      }
      // console.log("allImages", allImages);

      if (allImages) {
        setSelectedImages(allImages);
      }

      // setSelectedImages((previousImages) => previousImages.concat(imagesArray));

      // FOR BUG IN CHROME
      event.target.value = "";
    }
  };

  const onVideoSelectFile = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedFiles = event.target.files;
    // console.log("selectedFiles", selectedFiles);

    if (selectedFiles) {
      const selectedFilesArray = Array.from(selectedFiles);

      const videoArray = selectedFilesArray.map((file) => {
        // console.log(file);
        // setSelectedImages([...selectedImages, file]);
        return file;
      });

      try {
        // Check the duration of the video using react-player
        // const videoObjectUrl = URL.createObjectURL(selectedFiles[0]);
        // const videoPlayer = document.createElement("video");

        // videoPlayer.src = videoObjectUrl;
        // await videoPlayer.load();

        // const duration = videoPlayer.duration;
        // console.log("duration", duration);

        const videoObjectUrl = URL.createObjectURL(selectedFiles[0]);
        const videoPlayer = document.createElement("video");

        videoPlayer.src = videoObjectUrl;

        await new Promise((resolve) => {
          videoPlayer.onloadedmetadata = () => {
            resolve(undefined);
          };
        });

        const duration = videoPlayer.duration;
        console.log("duration", duration);

        // Define the maximum allowed duration (in seconds)
        const maxDuration = 60; // Adjust as needed

        if (duration > maxDuration) {
          showToast(
            `Video duration exceeds the maximum allowed (${maxDuration} seconds).`,
            "warn"
          );
          return;
        }

        setIsVideoCompressing(true);

        // Read the video file as ArrayBuffer
        const arrayBuffer = await selectedFiles[0].arrayBuffer();

        // Initialize FFmpeg worker
        const worker = new FFmpeg();

        await worker.load();
        console.log("load");

        // Convert ArrayBuffer to Uint8Array
        const uint8Array = new Uint8Array(arrayBuffer);
        console.log("array");

        // Run FFmpeg command to compress video and remove audio
        await worker.writeFile("input.mp4", uint8Array);
        console.log("write file");

        await worker.exec([
          "-i",
          "input.mp4",
          "-c",
          "copy",
          "-an",
          "output.mp4",
          // "-c:v",
          // "libx264",
          // "-an",
        ]);
        console.log("exec");

        // Read the compressed video from the worker's file system
        const data = await worker.readFile("output.mp4");
        const compressedVideoBlob = new Blob([data], { type: "video/mp4" });

        // Create a local URL for the compressed video
        const compressedVideoUrl = URL.createObjectURL(compressedVideoBlob);

        // Convert Blob to File
        const compressedVideoFile = new File(
          [compressedVideoBlob],
          "compressed_video.mp4",
          {
            type: "video/mp4",
            lastModified: Date.now(),
          }
        );

        // Set the compressed video File to state for further usage
        setCompressedVideo(compressedVideoFile);

        // Terminate the worker
        await worker.terminate();

        console.log(selectedFiles[0], compressedVideoFile);
        setSelectedVideo(selectedFiles[0]);
        setIsVideoCompressing(false);
        // setCompressedVideo(compressedVideoFile)
      } catch (error) {
        console.log(error);
        showToast(error as string, "error");
        setIsVideoCompressing(false);
      }

      // FOR BUG IN CHROME
      event.target.value = "";
    }
  };

  // useEffect(() => {
  //   console.log("selectedImages", selectedImages);
  // }, [selectedImages]);

  // const onSelectFile = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const selectedFiles = event.target.files;
  //   if (selectedFiles) {
  //     const selectedFilesArray = Array.from(selectedFiles);

  //     const promises = selectedFilesArray.map((file) => {
  //       return new Promise<string | ArrayBuffer | null>((resolve, reject) => {
  //         const reader = new FileReader();
  //         reader.onloadend = () => {
  //           resolve(reader.result);
  //         };
  //         reader.readAsDataURL(file);
  //       });
  //     });

  //     Promise.all(promises).then((imagesArray) => {
  //       setSelectedImages((previousImages) =>
  //         previousImages.concat(imagesArray as string[])
  //       );
  //     });

  //     // FOR BUG IN CHROME
  //     event.target.value = "";
  //   }
  // };

  // useEffect(() => {
  //   // setSelectedImages(gallery);
  //   setCategorizedImages({
  //     front: gallery[0] as File,
  //     back: gallery[1] as File,
  //     left: gallery[2] as File,
  //     right: gallery[3] as File,
  //     interiorFront: gallery[4] as File,
  //     interiorBack: gallery[5] as File,
  //   });
  //   setSelectedVideo(video);
  // }, []);

  const dispatch = useDispatch();

  useEffect(() => {
    const convertFilesAndDispatch = async () => {
      if (
        categorizedImages.front?.size &&
        categorizedImages.back?.size &&
        categorizedImages.left?.size &&
        categorizedImages.right?.size &&
        categorizedImages.interiorFront?.size &&
        categorizedImages.interiorBack?.size
      ) {
        const allImages = [
          categorizedImages.front,
          categorizedImages.back,
          categorizedImages.left,
          categorizedImages.right,
          categorizedImages.interiorFront,
          categorizedImages.interiorBack,
        ];

        // Await the resolution of Promise.all to get the array of base64 strings
        const strArr = await Promise.all(
          allImages.map(async (img) => await fileToBase64(img as File))
        );

        dispatch(
          setVehicle({
            gallery: strArr,
          })
        );
        console.log("dispatching...");
        console.log(gallery);
      }
    };

    // Call the async function
    convertFilesAndDispatch();
  }, [categorizedImages, dispatch]);

  useEffect(() => {
    if (compressedVideo) {
      dispatch(
        setVehicle({
          video: compressedVideo,
        })
      );
    }
  }, [compressedVideo, dispatch]);

  const handleDropUpload = (event: React.DragEvent<HTMLFormElement>) => {
    event.preventDefault();
    const selectedFiles = event.dataTransfer.files;
    if (selectedFiles) {
      const selectedFilesArray = Array.from(selectedFiles);

      const imagesArray = selectedFilesArray.map((file) => {
        // return URL.createObjectURL(file);
        return file;
      });

      setSelectedImages((previousImages) => previousImages.concat(imagesArray));
    }

    // if (selectedFiles) {
    //   const selectedFilesArray = Array.from(selectedFiles);

    //   const promises = selectedFilesArray.map((file) => {
    //     return new Promise<string | ArrayBuffer | null>((resolve, reject) => {
    //       const reader = new FileReader();
    //       reader.onloadend = () => {
    //         resolve(reader.result);
    //       };
    //       reader.readAsDataURL(file);
    //     });
    //   });

    //   Promise.all(promises).then((imagesArray) => {
    //     setSelectedImages((previousImages) =>
    //       previousImages.concat(imagesArray as string[])
    //     );
    //   });
    // }
    setIsDraggingOver(false);
  };

  useEffect(() => {
    console.log(gallery);
    if (gallery?.length >= 6) {
      setCategorizedImages({
        front: base64StringToFile(gallery[0] ?? ""),
        back: base64StringToFile(gallery[1]) ?? "",
        left: base64StringToFile(gallery[2] ?? ""),
        right: base64StringToFile(gallery[3] ?? ""),
        interiorFront: base64StringToFile(gallery[4] ?? ""),
        interiorBack: base64StringToFile(gallery[5] ?? ""),
      });
    }
  }, []);
  const navigate = useNavigate();

  if (isVideoCompressing) return <Loading loading={isVideoCompressing} />;

  return (
    <>
      <div className="flex flex-col w-[80%] lg:w-[70%] py-10 pl-5 lg:pl-0 border rounded-2xl mx-auto  h-full   bg-white">
        <div className="flex-col gap-2 px-10 ">
          <p className=" w-[90%] text-black text-left font-Poppins font-semibold lg:font-medium text-[18px] md:text-[19px]   ">
            Showcase your vehicle in Gallery
          </p>
          <p className=" w-[90%] flex flex-col font-Poppins text-left gap-1 text-[#ada5a5] text-[16px] font-normal  ">
            Add at least 6 attractive photos of your car
            <span className=" text-midGreen   ">
              Front, Back and both side, and interior views
            </span>
          </p>

          {/* <div className="flex flex-col  gap-3 w-full mx-auto py-5 ">
              <p className=" text-midGreen w-[90%] mx-auto font-Poppins text-[15px] font-normal underline cursor-pointer ">
                Image Guidelines
              </p>
              <div className="flex flex-wrap w-full justify-center ">
                <form
                  className={`flex flex-col justify-center items-center border-2 border-dashed border-midGreen w-[60%] lg:w-[20%]  cursor-pointer rounded-lg h-[140px] ${
                    isDraggingOver ? " scale-110 border-3 " : ""
                  }`}
                  onClick={() =>
                    (
                      document.querySelector(".upload1") as HTMLInputElement
                    )?.click()
                  }
                  onDrop={(e) => handleDropUpload(e)}
                  onDragOver={(e) => {
                    e.preventDefault();
                    setIsDraggingOver(true);
                  }}
                  onDragLeave={() => setIsDraggingOver(false)}
                >
                  <input
                    type="file"
                    accept="image/*"
                    placeholder="."
                    className="upload1"
                    multiple
                    hidden
                    onChange={onSelectFile}
                  />

                  <div className="flex flex-col gap-2 w-full justify-center items-center">
                    <BiSolidImageAdd size={25} color="#2ff77a" />
                    <p className="text-darkGreen flex flex-col gap-2 font-Poppins text-[12px] font-normal text-center">
                      Drag & Drop photos or
                      <span className="text-midGreen hover:underline">
                        Browse
                      </span>
                    </p>
                  </div>
                </form>
              </div>
              <div className="w-[90%] mx-auto flex items-center justify-start flex-shrink-0 flex-wrap gap-3 ">
                {selectedImages &&
                  selectedImages?.map((image, index) => (
                    <ImageCard
                      image={image}
                      onDelete={deleteHandler}
                      key={index}
                    />
                  ))}
                {addImageComponent && addImageComponent}
              </div>
            </div> */}

          <div className="w-full mx-auto flex flex-col my-10   ">
            <div className={`flex flex-wrap justify-start items-center gap-5 `}>
              {categorizedImages.front ? (
                <div className="w-[150px] h-[150px] lg:w-[200px] lg:h-[200px] relative">
                  <RiDeleteBin5Line
                    onClick={() =>
                      setCategorizedImages({
                        ...categorizedImages,
                        front: undefined,
                      })
                    }
                    className="text-red-600 text-[20px] cursor-pointer absolute right-0 m-2 contrast-150"
                  />
                  <img
                    src={URL.createObjectURL(categorizedImages.front)}
                    alt=""
                    className=" object-cover h-full w-full"
                  />
                </div>
              ) : (
                <div className="flex flex-col gap-2 border-2 border-dashed p-5 border-[#D0D5DD] rounded-xl w-[150px] h-[150px] lg:w-[200px] lg:h-[200px] justify-center items-center cursor-pointer ">
                  <label
                    htmlFor="frontImg"
                    className="flex flex-col gap-2 w-full justify-center items-center cursor-pointer"
                  >
                    <IoCloudUploadOutline size={25} color="#2ff77a" />

                    <p className="text-white bg-midGreen rounded-xl p-3 flex flex-col gap-2 font-Poppins text-[12px] font-normal text-center w-[95%] whitespace-nowrap">
                      Front
                    </p>
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    id="frontImg"
                    // capture="environment"
                    onChange={(e) => {
                      if (e.target.files?.length) {
                        setCategorizedImages({
                          ...categorizedImages,
                          front: e.target.files[0],
                        });
                      }
                    }}
                    hidden
                  />
                </div>
              )}

              {categorizedImages.back ? (
                <div className="w-[150px] h-[150px] lg:w-[200px] lg:h-[200px] relative">
                  <RiDeleteBin5Line
                    onClick={() =>
                      setCategorizedImages({
                        ...categorizedImages,
                        back: undefined,
                      })
                    }
                    className="text-red-600 text-[20px] cursor-pointer absolute right-0 m-2 contrast-150"
                  />
                  <img
                    src={URL.createObjectURL(categorizedImages.back)}
                    alt=""
                    className=" object-cover h-full w-full"
                  />
                </div>
              ) : (
                <div className="flex flex-col gap-2 border-2 border-dashed p-5 border-[#D0D5DD] rounded-xl w-[150px] h-[150px] lg:w-[200px] lg:h-[200px] justify-center items-center cursor-pointer ">
                  <label
                    htmlFor="backImg"
                    className="flex flex-col gap-2 w-full justify-center items-center cursor-pointer"
                  >
                    <IoCloudUploadOutline size={25} color="#2ff77a" />

                    <p className="text-white bg-midGreen rounded-xl p-3 flex flex-col gap-2 font-Poppins text-[12px] font-normal text-center w-[95%] whitespace-nowrap">
                      Back
                    </p>
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    id="backImg"
                    // capture="environment"
                    hidden
                    onChange={(e) => {
                      if (e.target.files?.length) {
                        setCategorizedImages({
                          ...categorizedImages,
                          back: e.target.files[0],
                        });
                      }
                    }}
                  />
                </div>
              )}

              {categorizedImages.left ? (
                <div className="w-[150px] h-[150px] lg:w-[200px] lg:h-[200px] relative">
                  <RiDeleteBin5Line
                    onClick={() =>
                      setCategorizedImages({
                        ...categorizedImages,
                        left: undefined,
                      })
                    }
                    className="text-red-600 text-[20px] cursor-pointer absolute right-0 m-2 contrast-150"
                  />
                  <img
                    src={URL.createObjectURL(categorizedImages.left)}
                    alt=""
                    className=" object-cover h-full w-full"
                  />
                </div>
              ) : (
                <div className="flex flex-col gap-2 border-2 border-dashed p-5 border-[#D0D5DD] rounded-xl w-[150px] h-[150px] lg:w-[200px] lg:h-[200px] justify-center items-center cursor-pointer ">
                  <label
                    htmlFor="leftImg"
                    className="flex flex-col gap-2 w-full justify-center items-center cursor-pointer"
                  >
                    <IoCloudUploadOutline size={25} color="#2ff77a" />

                    <p className="text-white bg-midGreen rounded-xl p-3 flex flex-col gap-2 font-Poppins text-[12px] font-normal text-center w-[95%] whitespace-nowrap">
                      Left Side
                    </p>
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    id="leftImg"
                    // capture="environment"
                    hidden
                    onChange={(e) => {
                      if (e.target.files?.length) {
                        setCategorizedImages({
                          ...categorizedImages,
                          left: e.target.files[0],
                        });
                      }
                    }}
                  />
                </div>
              )}

              {categorizedImages.right ? (
                <div className="w-[150px] h-[150px] lg:w-[200px] lg:h-[200px] relative">
                  <RiDeleteBin5Line
                    onClick={() =>
                      setCategorizedImages({
                        ...categorizedImages,
                        right: undefined,
                      })
                    }
                    className="text-red-600 text-[20px] cursor-pointer absolute right-0 m-2 contrast-150"
                  />
                  <img
                    src={URL.createObjectURL(categorizedImages.right)}
                    alt=""
                    className=" object-cover h-full w-full"
                  />
                </div>
              ) : (
                <div className="flex flex-col gap-2 border-2 border-dashed p-5 border-[#D0D5DD] rounded-xl w-[150px] h-[150px] lg:w-[200px] lg:h-[200px] justify-center items-center cursor-pointer ">
                  <label
                    htmlFor="rightImg"
                    className="flex flex-col gap-2 w-full justify-center items-center cursor-pointer"
                  >
                    <IoCloudUploadOutline size={25} color="#2ff77a" />

                    <p className="text-white bg-midGreen rounded-xl p-3 flex flex-col gap-2 font-Poppins text-[12px] font-normal text-center w-[95%] whitespace-nowrap">
                      Right Side
                    </p>
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    id="rightImg"
                    // capture="environment"
                    hidden
                    onChange={(e) => {
                      if (e.target.files?.length) {
                        setCategorizedImages({
                          ...categorizedImages,
                          right: e.target.files[0],
                        });
                      }
                    }}
                  />
                </div>
              )}

              {categorizedImages.interiorFront ? (
                <div className="w-[150px] h-[150px] lg:w-[200px] lg:h-[200px] relative">
                  <RiDeleteBin5Line
                    onClick={() =>
                      setCategorizedImages({
                        ...categorizedImages,
                        interiorFront: undefined,
                      })
                    }
                    className="text-red-600 text-[20px] cursor-pointer absolute right-0 m-2 contrast-150"
                  />
                  <img
                    src={URL.createObjectURL(categorizedImages.interiorFront)}
                    alt=""
                    className=" object-cover h-full w-full"
                  />
                </div>
              ) : (
                <div className="flex flex-col gap-2 border-2 border-dashed p-5 border-[#D0D5DD] rounded-xl w-[150px] h-[150px] lg:w-[200px] lg:h-[200px] justify-center items-center cursor-pointer ">
                  <label
                    htmlFor="interiorFront"
                    className="flex flex-col gap-2 w-full justify-center items-center cursor-pointer"
                  >
                    <IoCloudUploadOutline size={25} color="#2ff77a" />

                    <p className="text-white bg-midGreen rounded-xl p-3 flex flex-col gap-2 font-Poppins text-[12px] font-normal text-center w-[95%] whitespace-nowrap">
                      Interior Front
                    </p>
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    id="interiorFront"
                    // capture="environment"
                    hidden
                    onChange={(e) => {
                      if (e.target.files?.length) {
                        setCategorizedImages({
                          ...categorizedImages,
                          interiorFront: e.target.files[0],
                        });
                      }
                    }}
                  />
                </div>
              )}

              {categorizedImages.interiorBack ? (
                <div className="w-[150px] h-[150px] lg:w-[200px] lg:h-[200px] relative">
                  <RiDeleteBin5Line
                    onClick={() =>
                      setCategorizedImages({
                        ...categorizedImages,
                        interiorBack: undefined,
                      })
                    }
                    className="text-red-600 text-[20px] cursor-pointer absolute right-0 m-2 contrast-150"
                  />
                  <img
                    src={URL.createObjectURL(categorizedImages.interiorBack)}
                    alt=""
                    className=" object-cover h-full w-full"
                  />
                </div>
              ) : (
                <div className="flex flex-col gap-2 border-2 border-dashed p-5 border-[#D0D5DD] rounded-xl w-[150px] h-[150px] lg:w-[200px] lg:h-[200px] justify-center items-center cursor-pointer ">
                  <label
                    htmlFor="interiorBack"
                    className="flex flex-col gap-2 w-full justify-center items-center cursor-pointer"
                  >
                    <IoCloudUploadOutline size={25} color="#2ff77a" />

                    <p className="text-white bg-midGreen rounded-xl p-3 flex flex-col gap-2 font-Poppins text-[12px] font-normal text-center w-[95%] whitespace-nowrap">
                      Interior Back
                    </p>
                  </label>
                  <input
                    type="file"
                    accept="image/*"
                    id="interiorBack"
                    // capture="environment"
                    hidden
                    onChange={(e) => {
                      if (e.target.files?.length) {
                        setCategorizedImages({
                          ...categorizedImages,
                          interiorBack: e.target.files[0],
                        });
                      }
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {categorizedImages.front &&
          categorizedImages.back &&
          categorizedImages.left &&
          categorizedImages.right &&
          categorizedImages.interiorFront &&
          categorizedImages.interiorBack && (
            <div className="flex-col gap-2 px-10  w-[90%]">
              <p className=" w-full text-black text-left font-Poppins font-semibold lg:font-medium text-[18px] md:text-[19px]   ">
                Add extra images
              </p>
              <div className="w-full  mx-auto flex justify-start flex-wrap flex-col my-10   ">
                <ExtraImages />
              </div>
            </div>
          )}
        <div className="flex-col gap-2 px-10 w-[90%] ">
          <p className=" w-full text-black text-left font-Poppins font-semibold lg:font-medium text-[18px] md:text-[19px]   ">
            Video Only
          </p>
          <p className="w-full font-Poppins text-left flex gap-1 text-[#ada5a5] text-xs md:text-[14px] font-light  ">
            Capture Lessee’s attention with a video that showcases your vehicle.
            <br />
            Please choose a video not more than 60 seconds long and not more
            than 150MB in size.
          </p>
          <div className="w-full mx-auto justify-start flex flex-col my-10   ">
            {selectedVideo ? (
              <div className="w-[90%] mx-auto flex items-center justify-between flex-shrink-0 flex-wrap gap-3 relative ">
                {/* <ImageCard image={selectedVideo} onDelete={deleteHandler} /> */}
                {/* <span className=" absolute top-0 left-0 p-1 cursor-pointer bg-white border rounded-lg ">
                  <TiDeleteOutline
                    size={20}
                    color="red"
                    onClick={() => {
                      setSelectedVideo(undefined);
                    }}
                  />
                </span> */}

                <ReactPlayer
                  url={URL.createObjectURL(selectedVideo)}
                  controls
                  style={{ width: "100%", height: "100%" }}
                />
              </div>
            ) : (
              <div className="flex flex-wrap w-full justify-start ">
                <div
                  className={`flex flex-col justify-center items-center border-2 border-dashed cursor-pointer rounded-lg w-[150px] h-[150px] lg:w-[200px] lg:h-[200px] `}
                >
                  <label
                    htmlFor="video"
                    className="flex flex-col gap-2 w-full justify-center items-center cursor-pointer"
                  >
                    <IoCloudUploadOutline size={25} color="#2ff77a" />

                    <p className="text-white bg-midGreen rounded-xl p-3 flex flex-col gap-2 font-Poppins text-[12px] font-normal text-center w-[90%] whitespace-nowrap">
                      Add Video
                    </p>
                  </label>
                  <input
                    type="file"
                    accept="video/*"
                    placeholder="."
                    className="uploadVideo"
                    id="video"
                    // multiple
                    hidden
                    onChange={onVideoSelectFile}
                  />

                  {/* <div className="flex flex-col gap-2 w-full justify-center items-center">
                    <BiSolidImageAdd size={25} color="#2ff77a" />
                    <p className="text-darkGreen flex flex-col gap-2 font-Poppins text-[12px] font-normal text-center">
                      Drag & Drop Video or
                      <span className="text-midGreen hover:underline">
                        Browse
                      </span>
                    </p>
                  </div> */}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Gallery;
